import { ReactComponent as HomeIcon } from 'assets/Icons/Home.svg'
import { ReactComponent as IncentivesIcon } from 'assets/Icons/Tag.svg'
import { ReactComponent as ReportsIcon } from 'assets/Icons/Pie-Chart.svg'
import { ReactComponent as SettingsIcon } from 'assets/Icons/Settings.svg'
import { ReactComponent as TeamIcon } from 'assets/Icons/Team.svg'
import { SideNavItemProps } from 'components/SideNavItem'
import BillingContainer from 'containers/BillingContainer'
import ConnectionsContainer from 'containers/ConnectionsContainer'
import { HelpContainer } from 'containers/HelpContainer'
import CompaniesHomeContainer from 'containers/CompaniesHomeContainer'
import { IncentiveContainer } from 'containers/IncentiveContainer'
import { IncentivesContainer } from 'containers/IncentivesContainer'
import { ProfileContainer } from 'containers/ProfileContainer'
import { TeamContainer } from 'containers/TeamContainer'
import EmployeesContainer from 'containers/EmployeesContainer'
import { RouteMap } from 'lib/router'
import ComingSoon from 'views/ComingSoon'
import NotFound from 'views/NotFound'
import CompanySettings from 'views/Settings/CompanySettings'

export const companyRoutes: RouteMap<SideNavItemProps> = [
  {
    path: '/',
    exact: true,
    component: CompaniesHomeContainer,
    navTitle: 'pmportal.nav.home',
    navIcon: HomeIcon,
  },
  {
    path: '/workspaces/:workspaceId/employees',
    component: EmployeesContainer,
    navTitle: 'pmportal.nav.employees',
    navIcon: TeamIcon,
  },
  {
    path: '/workspaces/:workspaceId/incentives/:incentivePlanId',
    component: IncentiveContainer,
    navTitle: 'pmportal.nav.incentives',
  },
  {
    path: '/workspaces/:workspaceId/incentives',
    component: IncentivesContainer,
    navTitle: 'pmportal.nav.incentives',
    navIcon: IncentivesIcon,
    featureFlag: 'hera_incentive_plans',
  },
  {
    path: '/workspaces/:workspaceId/reports',
    render: () => (
      <ComingSoon
        title="pmportal.reports.title"
        description="pmportal.reports.description"
      />
    ),
    navTitle: 'pmportal.nav.reports',
    navIcon: ReportsIcon,
    statusBadge: 'comingSoon',
  },
  {
    path: '/workspaces/:workspaceId/settings/help',
    component: HelpContainer,
    breadcrumb: 'pmportal.nav.help',
  },
  {
    path: '/workspaces/:workspaceId/settings/billing',
    component: BillingContainer,
    breadcrumb: 'pmportal.nav.billing',
  },
  {
    path: '/workspaces/:workspaceId/settings/history',
    render: () => (
      <ComingSoon
        title="pmportal.history.title"
        description="pmportal.history.description"
      />
    ),
    breadcrumb: 'pmportal.nav.history',
  },
  {
    path: '/workspaces/:workspaceId/settings/team',
    component: TeamContainer,
    breadcrumb: 'pmportal.nav.team',
  },
  {
    path: '/workspaces/:workspaceId/settings/profile',
    component: ProfileContainer,
    breadcrumb: 'pmportal.nav.myProfile',
  },
  {
    path: '/workspaces/:workspaceId/settings/connections',
    component: ConnectionsContainer,
    breadcrumb: 'pmportal.nav.connections',
  },
  {
    path: '/workspaces/:workspaceId/settings',
    component: CompanySettings,
    navTitle: 'pmportal.nav.settings',
    navIcon: SettingsIcon,
    breadcrumb: 'pmportal.nav.settings',
  },
  {
    path: '*',
    component: NotFound,
  },
]
